<template>
  <main role="main">

    <section class="jumbotron text-center" style="width: 100%; display: flex; justify-content: center;">
      <div style="width: 90%; margin-top: -1cm">
        <h1 style="font-family:华文新魏; color:#446FB4;">鹰迅课堂项目介绍</h1>
        <p class="lead text-muted m-3 text-left">
          鹰迅课堂项目由<b><font color="#FFC000">吉林省 “互联网＋” 大赛金奖</font></b>，挑战杯特等奖、<b>
          <font color="#0077F6">国家级铜奖项目主持人吴灿锦</font>
        </b>于2022年开发完成，项目于2022年获得吉林财经大学大学生创业实践<b><font
            color="#0077F6">国家级立项第一名</font></b>。
        </p>
        <p class="lead text-muted m-3 text-left">
          后端主要采用SpringBoot、SpringCouldAlibaba，Redis，RabbitMQ，ElasticSearch，XXL-JOB等技术栈进行开发。前端主要使用Vue框架实现单页应用以及使用ElementUI组件库提高开发效率。
        <p class="lead text-muted m-3 text-left">
        <font color="#FFC000"><b>鹰迅课堂地址：</b></font>
        </p>

        <p class="lead text-muted m-3 text-left">
          <a href="http://47.106.168.209:8887" target="_blank">管理员端地址：http://yxclass.net:8887</a>
        </p>

        <p class="lead text-muted m-3 text-left">
          <a href="http://47.106.168.209:8888" target="_blank">前台学员端地址：http://yxclass.net:8888</a>
        </p>

        <p class="lead text-muted m-3 text-left">
          本人的毕业设计——《基于SpringCloud
          Alibaba微服务在线教育系统的设计与实现》获得<font
            color="#0077F6"><b>吉林财经大学优秀毕业设计，可辅导毕业设计系统的开发与设计，带你像鹰一样迅速完成毕业设计。</b></font>
        </p>
        <p class="lead text-muted m-3 text-left">
          <font color="#FFC000"><b>商务微信公众号：远方的音讯</b></font>
        </p>
        <p class="lead text-muted m-3 text-left">
          <font color="#FFC000"><b>商务合作微信号：yxclass_wcj</b></font>
        </p>
        <p>
          <router-link to="/list" class="btn btn-primary my-2 p-3 font-weight-bold">点击进入所有课程</router-link>
        </p>
      </div>

    </section>

    <div class="album py-5 bg-light">
      <div class="container">
        <div class="title1">最新上线</div>
        <div class="row">
          <div v-for="o in news" class="col-md-4">
            <the-course v-bind:course="o"></the-course>
          </div>
        </div>
        <hr>
        <div class="title2">好课推荐</div>
        <div class="row">
          <div v-for="o in news" class="col-md-4">
            <the-course v-bind:course="o"></the-course>
          </div>
        </div>
      </div>
    </div>

  </main>
</template>

<script>
// 导入需要注册的组件
// import 组件对象 from '.vue文件路径'
import TheCourse from "../components/the-course";

export default {// 局部注册
  name: 'index',
  components: {TheCourse},
  data: function () {
    return {
      news: [],
    }
  },
  created() {
    let _this = this;
    _this.listNew();
  },
  mounted() {

  },
  methods: {
    /**
     * 查询新上好课
     */
    listNew() {
      let _this = this;
      // 新上好课不经常变，又经常被访问，适合用缓存
      // 判断是否有缓存
      let news = SessionStorage.get("news");
      if (!Tool.isEmpty(news)) {
        _this.news = news;
        return;
      }

      _this.$ajax.get(process.env.VUE_APP_SERVER + '/business/web/course/list-new').then((response) => {
        console.log("查询新上好课结果：", response);
        let resp = response.data;
        if (resp.success) {
          _this.news = resp.content;
          // 保存到缓存
          SessionStorage.set("news", _this.news);
        }
      }).catch((response) => {
        console.log("error：", response);
      })
    },
    }
  }
</script>

<style>
  .title1{
    margin-bottom: 2rem;
    color: #fafafa;
    letter-spacing: 0;
    text-shadow: 0px 1px 0px #999, 0px 2px 0px #888, 0px 3px 0px #777, 0px 4px 0px #666, 0px 5px 0px #555, 0px 6px 0px #444, 0px 7px 0px #333, 0px 8px 7px #001135;
    font-size: 2rem;
  }
  .title2{
    margin-bottom: 2rem;
    color: transparent;
    -webkit-text-stroke: 1px black;
    letter-spacing: 0.04em;
    font-size: 2rem;
  }
</style>
